import { render, staticRenderFns } from "./SaasProfile.vue?vue&type=template&id=1b81391c&scoped=true"
import script from "./SaasProfile.vue?vue&type=script&lang=js"
export * from "./SaasProfile.vue?vue&type=script&lang=js"
import style0 from "./SaasProfile.vue?vue&type=style&index=0&id=1b81391c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81391c",
  null
  
)

export default component.exports